// extracted by mini-css-extract-plugin
module.exports = {"lia-sort-list":"MessageListMenu_lia-sort-list__uT2CV"};